<template>
  <div class="app-container">
    <div class="app-content">
      <!-- 搜索框 -->
      <div class="search">
        <p class="title">Welcome to Fanvil Knowledge Base</p>
        <div class="search-center">
          <i class="el-icon-search" @click="enterSearch"></i>

          <el-input
            placeholder="Please enter keywords to search"
            v-model="data.keyword"
            @input="debounceSearch"
            @keyup.enter.native="enterSearch"
          >
          </el-input>
          <!-- <img src="../assets/images/疑问.png" alt="" /> -->
          <div class="answer" v-if="contList.length">
            <ul>
              <li
                v-for="(item, index) in contList"
                :key="index"
                @click="enterArticle(item, '1')"
              >
                <p v-html="item.title"></p>
                <span v-html="item.htmlContent"></span>
              </li>
            </ul>
          </div>
        </div>
        <ul>
          <li
            v-for="(item, index) in hotTxtList"
            :key="index"
            @click="enterSearch(item)"
          >
            {{ item.keyWord }}
          </li>
        </ul>
      </div>

      <div class="main-cont">
        <!-- 模块 -->
        <div class="model">
          <p>Knowledge Base</p>
          <ul>
            <li
              @click="enterText(item)"
              v-for="item in modelList"
              :key="item.id"
            >
              <img :src="`${baseUrl}${item.imageUrl}`" alt="" />
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>

        <!-- 文章 -->
        <div class="text">
          <div class="hot-text">
            <p>Latest updated articles</p>
            <ul>
              <li
                @click="enterArticle(item)"
                v-for="item in newList"
                :key="item.id"
              >
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </div>
          <div class="new-text">
            <p>Top articles</p>
            <ul>
              <li
                @click="enterArticle(item)"
                v-for="item in numList"
                :key="item.id"
              >
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>
        Copyright © 2022
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >粤ICP备15049600号</a
        >
        Fanvil Technology Co., Ltd.
      </p>
    </div>

    <!-- 弹窗:搜索提示 -->
    <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span
        >以下是一些搜索提示，可帮助您在Fanvil Knownledge Base找到所需内容。<br /><br />
        1.搜索文档或视频时推荐的关键字。
        发行说明、数据表、安装和部署（或安装和连接）、快速入门、用户指南、管理员指南、平台操作指南<br /><br />
        2.除了在知识库页面上搜索外，您还可以选择一个产品模块（例如团队设备），然后在所选产品中搜索所需的内容。
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import {
  getModel,
  getUrl,
  getMoreText,
  getNewText,
  getHot,
  getText,
  getHotText,
  updateHot,
} from "../api/directory";
import { login } from "../api/login";

export default {
  data() {
    return {
      dialogVisible: false,
      modelList: [], //模块列表
      numList: [], //点击量前五
      newList: [], //最新文章
      // baseUrl: process.env.VUE_APP_API_URL,
      baseUrl: "https://kb.fanvil.com",
      contList: [], //搜索关键词
      hotTxtList: [], //搜索热词
      data: {
        keyword: "",
        page: 1,
        pageSize: 10,
      },
      user: {
        username: "user",
        password: "123456",
      },
    };
  },
  computed: {
    display() {
      return this.$store.state.tab.showMenu;
    },
  },
  methods: {
    // 获取目录列表
    async getList() {
      try {
        const res = await getModel({ level: 0 });
        const tableData = res.data;

        const promises = tableData.map(async (item) => {
          const imageId = item.imageId;
          const res = await getUrl(imageId);
          item.imageUrl = res.data.mediaUrl;
          return item;
        });

        await Promise.all(promises);
        this.modelList = tableData;

        // 返回一个 Promise 表示完成
        return Promise.resolve();
      } catch (error) {
        console.error("Error in getList:", error);
        return Promise.reject(error);
      }
    },
    getUser() {
      login(this.user)
        .then(async (res) => {
          const token = res.data.token;
          localStorage.setItem("token", token);

          await this.getList(); // 等待 getList 完成
          this.getSearchTxt(); // getList 完成后再执行
          this.getNumList();
          this.getNewList();
        })
        .catch((error) => {
          console.error("Login failed:", error);
        });
    },

    // 获取点击量前五文章列表
    getNumList() {
      getMoreText().then((res) => {
        this.numList = res.data.articles;
      });
    },

    // 获取最新文章
    getNewList() {
      getNewText().then((res) => {
        this.newList = res.data.articles;
      });
    },

    // 获取搜索热词
    getSearchTxt() {
      getHot().then((res) => {
        this.hotTxtList = res.data.keywords;
      });
    },

    // 搜索关键词
    searchList() {
      if (this.data.keyword) {
        getHotText(this.data).then((res) => {
          this.contList = res.data.articles.slice(0, 5);
        });
      } else {
        this.contList = [];
      }
    },

    debounceSearch() {
      // 清除旧的定时器
      if (this.timer) {
        clearTimeout(this.timer);
      }
      // 设置新的定时器，在1秒后执行searchList方法
      this.timer = setTimeout(() => {
        this.searchList();
      }, 800);
    },

    // 进入内容板块
    enterText(item) {
      this.$router.push({
        path: "/model",
        query: { label: item.name, dirid: item.id, level: 2 },
      });
      // localStorage.setItem('dirId', this.$route.query.id);
      // const label = { label: item.name, id: item.id, level: 2 };
      // this.$store.commit("selectMenu", label);
    },

    // 进入文章内容
    enterArticle(item, type) {
      if (type) {
        updateHot(JSON.stringify(this.data.keyword));
      }
      getText(item.id).then((res) => {
        var dirid = res.data.category.id;
        var dirName = res.data.category.name;
        this.$router.push({
          path: "/model",
          query: { label: dirName, dirid: dirid, itemId: item.id, level: 2 },
        });
      });
    },

    // 进入搜索页
    enterSearch(item) {
      let keyword = item.keyWord || this.data.keyword;
      updateHot(JSON.stringify(keyword)).then((res) => {
        this.$router.push({
          path: "/search",
          query: { name: keyword },
        });
      });
    },
  },
  mounted() {
    this.getUser();
  },
};
</script>
<style lang="less" scoped>
.el-dialog {
  span {
    font-size: 15px;
  }
}
.app-container {
  min-height: 100%;
  width: 100%;

  .search {
    padding-top: 90px;
    width: 100%;
    background: url(../assets/images/图片.jpg) no-repeat 50% / cover;

    > p {
      margin-bottom: 60px;
      font-size: 55px;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 44px;
    }

    .search-center {
      width: 680px;
      position: relative;
      margin: 0 auto;
      padding-bottom: 30px;

      .el-icon-search {
        position: absolute;
        top: 10px;
        left: 20px;
        font-size: 22px;
        color: #ffffff;
        z-index: 999;

        &:hover {
          cursor: pointer;
          color: red;
        }
      }

      img {
        position: absolute;
        top: 10px;
        right: -30px;
        cursor: pointer;
      }

      /deep/.el-input {
        position: relative;
        width: 100%;

        .el-input__inner {
          border-radius: 20px;
          border: none;
          padding: 0 50px 0 55px;
          height: 44px;
          background-color: rgba(255, 255, 255, 0.35);
          color: white;
          font-size: 17px;

          &::placeholder {
            color: white;
            font-size: 17px;
            font-weight: bold;
            letter-spacing: 1px;
            font-family: "Times New Roman";
          }
        }

        .el-input__icon {
          font-size: 22px;
          color: #ffffff;
          cursor: pointer;

          &:hover {
            color: red;
          }
        }

        .el-input__prefix {
          padding-left: 20px;
        }
      }

      .answer {
        position: absolute;
        top: 52px;
        left: 0;
        z-index: 99;
        border-radius: 16px;
        width: 680px;
        background-color: #fff;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);

        ul {
          padding: 20px 0;
          margin: 0;
          max-height: 60vh;
          overflow-y: auto;

          li {
            padding: 20px 20px;
            display: block;
            text-align-last: left;
            cursor: pointer;

            &:hover {
              background-color: #e9f0fb63;
            }
          }
        }
      }
    }

    > ul {
      width: 30%;
      list-style: none;
      color: white;
      margin: 0 auto;
      padding-bottom: 40px;
      text-align: center;
      font-size: 18px;
      min-height: 20px;
      font-weight: bold;
      > li {
        display: inline-block;
        margin-right: 20px;
      }
      li:hover {
        color: red;
        cursor: pointer;
      }
    }
  }

  .main-cont {
    width: 1200px;
    margin: 30px auto 0;

    // 模块
    .model {
      width: 100%;

      > p {
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 6px;
        border-bottom: 1px solid #e0e6e9;
      }

      ul {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        list-style: none;
        padding: 0;
        margin: 10px auto 0;

        li {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          background-color: #e9f1f6;
          white-space: nowrap;
          width: 290px;
          padding: 12px 0 12px 10px;
          border-radius: 6px;
          margin: 0 11px 10px 0;
          cursor: pointer;
          box-sizing: border-box;
          letter-spacing: -1px;

          &:hover {
            color: red;
          }

          &:nth-of-type(4n) {
            margin-right: 0;
          }

          img {
            width: 32px;
            margin-right: 6px;
          }

          p {
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }

    // 文章
    .text {
      display: flex;
      justify-content: space-between;

      p {
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 6px;
        border-bottom: 1px solid #e0e6e9;
      }

      ul {
        padding-left: 25px;

        li {
          cursor: pointer;
          font-size: 17px;
          margin-bottom: 12px;

          span {
            color: #202020;
            cursor: pointer;
            margin: 0;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
          }
        }

        li:hover {
          span {
            color: red;
          }
        }
      }

      .hot-text,
      .new-text {
        width: 45%;
        padding-top: 25px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 20px;
    padding: 11px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 12px;
    text-align: center;
    color: #333;
    background-color: white;
    margin-top: 80px;

    a {
      text-decoration: none;
      color: #333;

      &:hover {
        cursor: pointer;
        color: red;
      }
    }
  }

  /deep/.el-dialog {
    border-radius: 15px;
  }
  /deep/.el-dialog__header {
    text-align: center;
    font-weight: bold;
  }
  /deep/.el-dialog__body {
    padding: 30px 40px 80px 40px;
    font-size: 14px;
  }
}
</style>
